import http from '../http'
import { Res } from '../type'
import { GoodsPage, GoodsPageParams } from '../Models/GoodsPage'
import { DeliveryAreas, GoodsGet, GoodsGetParams, MerchantDetail4C } from '../Models/GoodsGet'
import { UserIntegralIndexParams, UserIntegralIndex, GoodsCategoryRes } from '../Models/UserIntegralIndex'
import { GoodsCheckBuyParams, GoodsCheckBuy } from '../Models/GoodsCheckBuy'

export const getGoodsPage = (params: GoodsPageParams): Res<GoodsPage> => {
  return http.request({
    url: '/sands-shopping/api/v1/goods/page',
    method: 'POST',
    data: params,
    loadingShow: '0'
  })
}

export const getGoodsDetail = (params: GoodsGetParams): Res<GoodsGet> => {
  return http.request({
    url: '/sands-shopping/api/v1/goods/get',
    method: 'GET',
    params,
    loadingShow: '0'
  })
}

export const getShopIndex = (): Res<UserIntegralIndex> => {
  return http.request({
    url: '/sands-shopping/api/v1/integral/user-integral/index',
    method: 'GET',
    loadingShow: '0'
  })
}

export const goodsCheckBuy = (data: GoodsCheckBuyParams): Res<GoodsCheckBuy> => {
  return http.request({
    url: '/sands-shopping/api/v1/goods/checkBuy',
    method: 'POST',
    data
  })
}

export const goodsCategory = (data: UserIntegralIndexParams): Res<GoodsCategoryRes> => {
  return http.request({
    url: '/sands-shopping/api/v1/goods/category/list',
    method: 'POST',
    data
  })
}

export const getMerchantDetail = (params: UserIntegralIndexParams): Res<MerchantDetail4C> => {
  return http.request({
    url: '/sands-shopping/api/v1/merchant/getMerchantDetail',
    method: 'GET',
    params,
    loadingShow: '0',
    toastShow: '0'
  })
}

// 获取配送地区
export const getDeliveryAreas = (params: UserIntegralIndexParams): Res<DeliveryAreas> => {
  return http.request({
    url: '/sands-shopping/api/v1/merchant/getDeliveryAreas',
    method: 'GET',
    params,
    loadingShow: '0'
  })
}
